import * as React from 'react'
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { IconButton } from '@mui/material';
import { useDarkMode } from './DarkModeProvider';

type Props = {

}

const DarkModeSwitch: React.FC<Props> = ({ }) => {
  const darkMode = useDarkMode();

  return (
    <div className=' cursor-pointer flex items-center hover:text-viking-700' onClick={() => darkMode.setDark(!darkMode.isDark)}>
      {/* <IconButton> */}
      {darkMode.isDark &&
        <React.Fragment>
          <LightModeIcon color="inherit" fontSize="inherit" className="mr-1 text-xl" /> Light
        </React.Fragment>
      }
      {!darkMode.isDark &&
        <React.Fragment>
          <DarkModeIcon color="inherit" fontSize="inherit" className="mr-1 text-xl" /> Dark
        </React.Fragment>
      }
      {/* </IconButton> */}
    </div>
  );
}

export default DarkModeSwitch;

